import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledAlert = styled.div`
  ${rtl`
  .alert-container{
    padding:0;
  }
  padding:0;
  .map-view {
    margin-top: ${toRem(0)};
    width: ${toRem(332)};
    margin-right: ${toRem(8)};
    .alert{
      padding: ${toRem(12)} !important;
    }
  }
  .warning-container{
    padding-top:${toRem(16)};
    padding-bottom:${toRem(16)};
  }
  .alert {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: ${theme.color.white};
    padding: ${toRem(12)} ${toRem(16)};
    border-radius: ${toRem(8)};
    &.m-alert-inline-info {
      border: ${toRem(1)} solid ${theme.color['close-silver']};
      color: ${theme.color['cod-grey']};
      .m-alert-inline-contentWrap{
        display: flex;
      }
    }
    &.m-alert-inline-no-availability,
    &.m-alert-inline-no-hotels,
    &.m-alert-inline-result-not-found,
    &.m-alert-inline-search-form-near,
    &.m-alert-inline-property-search {
      border: ${toRem(1)} solid ${theme.color['dark-red']};
      background-color: ${theme.color['carousel-pink']};
      .m-alert-inline-contentWrap {
        display: flex;
      }
      .icon-information {
        color: ${theme.color['dark-red']};
      }
      .link-error-message{
        text-decoration: underline;
        font-weight: 700;
        &:hover {
          font-weight: 500;
        }
      }
    }
    
    &.m-alert-inline-warning {
      border: ${toRem(1)} solid ${theme.color['rose-of-sharon']};
      color: ${theme.color['rose-of-sharon']};
      .m-alert-inline-contentWrap {
        display: flex;
      }
      .icon-warning {
        color: ${theme.color['rose-of-sharon']};
      }
      a {
        color: ${theme.color['rose-of-sharon']};
        text-decoration: underline;
        &:hover{
          font-weight: unset !important;
        }
      }
    }
    &.m-alert-inline-success {
      border: ${toRem(1)} solid ${theme.color['verdun-green']};
      color: ${theme.color['verdun-green']};
      text-align: left;

      .m-alert-inline-contentWrap {
        display: flex;
        .alert-heading{
          color: ${theme.color['verdun-green']};
        }
        .link-error-message{
          color: ${theme.color['verdun-green']};
          text-decoration: underline;
          &:hover {
            font-weight: 500;
          }
        }
      }
    }
    &.m-alert-inline-alert {
      border: ${toRem(1)} solid ${theme.color['close-silver']};
      color: ${theme.color['cod-grey']};
      .m-alert-inline-contentWrap {
        display: flex;
      }
      .link-error-message {
        font-weight: 700;
        text-decoration: underline;
        &:hover {
          font-weight: ${baseVariables.font['fontWeightMedium']};
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    width: 100%;

    .alert {
      margin-top: ${toRem(8)};
      .m-alert-inline-contentWrap {
        .m-alert-inline-content {
          padding: 0 !important;
        }
      }
    }
    .warning-container{
      margin-right: 1rem;
      margin-left: 1rem;
    }
  }
  @media only ${theme.mediaQuery.allTablets}{
    .warning-container{
      width: auto;
     }
  }
  `}
`;
